var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-blog"},[(_vm.blog.handle == 'digital-locket')?_c('BlogLocket',{attrs:{"blog":_vm.blog}}):_vm._e(),_vm._v(" "),(_vm.blog.handle == 'journal')?_c('BlogJournal',{attrs:{"blog":_vm.blog}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }